// Generated by genversion.
export const version = '12.1.0'
